import { render, staticRenderFns } from "./encuestasTabs.vue?vue&type=template&id=2ecbaa47&scoped=true&"
import script from "./encuestasTabs.vue?vue&type=script&lang=js&"
export * from "./encuestasTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecbaa47",
  null
  
)

export default component.exports